(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  function obs(){document.querySelectorAll('.sixsix-reveal:not(.in)').forEach(function(el){io.observe(el);});}

  function wrapLogos(){
    try{
      var sels='.site-header__logo-image,.site-header__logo img,.header-item--logo img';
      var anchors=[];
      document.querySelectorAll(sels).forEach(function(img){
        var a=img.closest('a')||img.parentElement;
        if(a&&anchors.indexOf(a)===-1)anchors.push(a);
      });
      anchors.forEach(function(a){
        if(a.classList.contains('sixsix-logo-swap')||a.closest('.sixsix-logo-swap'))return;
        var f1=document.createElement('span');f1.className='sixsix-face sixsix-face-img';
        while(a.firstChild){f1.appendChild(a.firstChild);}
        var f2=document.createElement('span');f2.className='sixsix-face sixsix-face-text sixsix-hidden';
        var t=document.createElement('span');t.className='sixsix-logo-text';t.textContent='66HUNDRED';
        var t2=document.createElement('span');t2.textContent='\u516d\u5343\u516d\u767e';
        t.appendChild(t2);f2.appendChild(t);
        a.classList.add('sixsix-logo-swap');a.appendChild(f1);a.appendChild(f2);
      });
    }catch(e){}
  }

  function sizeWraps(){
    try{
      document.querySelectorAll('.sixsix-logo-swap').forEach(function(a){
        if(a.dataset.sixsixSized)return;
        var f1=a.querySelector('.sixsix-face-img');if(!f1)return;
        var r=f1.getBoundingClientRect();
        if(r.height>10&&r.width>10){
          a.style.minHeight=Math.round(r.height)+'px';
          a.style.minWidth=Math.round(r.width)+'px';
          a.dataset.sixsixSized='1';
        }
      });
    }catch(e){}
  }

  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function swapAll(){
    try{
      wrapLogos();sizeWraps();
      document.querySelectorAll('.sixsix-logo-swap').forEach(function(wrap){
        var f1=wrap.querySelector('.sixsix-face-img'),f2=wrap.querySelector('.sixsix-face-text');
        if(!f1||!f2)return;
        if(!reduced){
          f1.classList.add('sixsix-glitching');f2.classList.add('sixsix-glitching');
          setTimeout(function(){f1.classList.remove('sixsix-glitching');f2.classList.remove('sixsix-glitching');},300);
        }
        setTimeout(function(){f1.classList.toggle('sixsix-hidden');f2.classList.toggle('sixsix-hidden');},reduced?0:140);
      });
    }catch(e){}
    setTimeout(swapAll,2500+Math.random()*3500);
  }

  function stickyTick(){
    try{
      sizeWraps();
      var h=document.querySelector('.site-header');if(!h)return;
      var sc=window.scrollY>60;
      h.classList.toggle('sixsix-scrolled',sc);
      if(sc){
        h.style.setProperty('background','rgba(255,255,255,.96)','important');
        h.style.setProperty('backdrop-filter','blur(6px)','important');
        h.style.setProperty('box-shadow','0 1px 0 rgba(20,19,18,.16)','important');
      }else{
        h.style.removeProperty('background');
        h.style.removeProperty('backdrop-filter');
        h.style.removeProperty('box-shadow');
      }
    }catch(e){}
  }
  function initSticky(){
    var h=document.querySelector('.site-header');if(!h)return;
    if(!document.querySelector('.sixsix-hero')){
      document.documentElement.style.setProperty('--sixsix-header-h',h.offsetHeight+'px');
      document.body.classList.add('sixsix-pad-header');
    }
    window.addEventListener('scroll',stickyTick,{passive:true});
    setInterval(stickyTick,800);
    stickyTick();
  }

  function start(){
    obs();
    wrapLogos();
    sizeWraps();
    initSticky();
    window.addEventListener('load',sizeWraps);
    setTimeout(swapAll,1500);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();